"use client";

import { useTranslations } from "next-intl";
import { Breadcrumbs } from "@/components/layout/breadcrumbs";
import { StoryFilms } from "@/components/why-story/story-films";

/** "Why BB" as a 16:9 animated story, plus one film per kind of member. */
export default function WhyStoryPage() {
  const t = useTranslations("whyStory");
  return (
    <div className="px-page py-6 space-y-4">
      <Breadcrumbs items={[{ navKey: "whyBb", href: "/dashboard?tab=why" }, { label: t("title") }]} />
      <StoryFilms />
    </div>
  );
}
